import { render } from "./login.vue?vue&type=template&id=c5a43204&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=c5a43204&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c5a43204"

export default script